<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="24.73" viewBox="0 0 13 24.73">
        <path class="ribbon" fill="#a5d867" d="M29.4,24.73V0h13V24.53l-6.39-5.793L29.4,24.728Z" transform="translate(-29.397)"/>
    </svg>
</template>

<script>
export default {
  name: 'RibbonIcon'
}
</script>

<style scoped>
    svg {
        width: 13px;
        height: 24.73px;
    }
    .blueYear path {
        fill: #002B45;
    }
    .theme--dark .blueYear path {
        fill: #5b6d81;
    }
    .greenYear path {
        fill: #024731;
    }
    .theme--dark .greenYear path {
        fill: #5e8372;
    }
    .redYear path {
        fill: #6E273D;
    }
    .theme--dark .redYear path {
        fill: #a26f7b;
    }
</style>